import { render } from "./close.svg?vue&type=template&id=2908912e"
const script = {}
script.render = render

export default script